module.exports = __webpack_public_path__ + "img/productBgImg22.41e41c44.png";